import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { executionLogsAccountsGroupedByProviderSelector } from "./executionLogsAccountsGroupedByProviderSelector";
import { accountSelectionOptionsCombiner } from "../../combiners/accountSelectionOptionsCombiner";
import { accountsGroupedByProviderAndOrgCombiner } from "../../combiners/accountsGroupedByProviderAndOrgCombiner";

export const executionLogsAccountsGroupedByProviderAndOrganization =
  createDraftSafeSelector(
    [executionLogsAccountsGroupedByProviderSelector],
    (accounts) => {
      const accountsGroupedByProviderAndOrg =
        accountsGroupedByProviderAndOrgCombiner(accounts);

      return accountSelectionOptionsCombiner(accountsGroupedByProviderAndOrg);
    },
  );
